import React from 'react';
import { Linkedin, Twitter, Instagram } from 'lucide-react';
import { Logo } from './Logo';

export const LandingFooter: React.FC = () => {
  return (
    <footer className="bg-white border-t border-gray-100 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          <div className="col-span-1 md:col-span-1">
            <Logo className="mb-4" />
            <p className="text-sm text-gray-500 leading-relaxed max-w-xs">
              Empowering developers and planners with unified data insights for smarter city growth.
            </p>
          </div>

          <div>
            <h4 className="font-bold text-gray-900 mb-4">Platform</h4>
            <ul className="space-y-3">
              <li><button className="text-sm text-gray-500 hover:text-primary transition-colors">Data Sources</button></li>
              <li><button className="text-sm text-gray-500 hover:text-primary transition-colors">Coverage</button></li>
              <li><button className="text-sm text-gray-500 hover:text-primary transition-colors">Pricing</button></li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-gray-900 mb-4">Resources</h4>
            <ul className="space-y-3">
              <li><button className="text-sm text-gray-500 hover:text-primary transition-colors">Documentation</button></li>
              <li><button className="text-sm text-gray-500 hover:text-primary transition-colors">API Access</button></li>
              <li><button className="text-sm text-gray-500 hover:text-primary transition-colors">Blog</button></li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-gray-900 mb-4">Connect</h4>
            <a href="mailto:hello@kshetram.land" className="text-sm text-primary hover:underline block mb-4 font-medium">
              hello@kshetram.land
            </a>
            <div className="flex gap-4">
              <button className="text-gray-400 hover:text-primary transition-colors bg-gray-50 p-2 rounded-full"><Linkedin size={18} /></button>
              <button className="text-gray-400 hover:text-primary transition-colors bg-gray-50 p-2 rounded-full"><Twitter size={18} /></button>
              <button className="text-gray-400 hover:text-gray-900 transition-colors bg-gray-50 p-2 rounded-full"><Instagram size={18} /></button>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-100 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-gray-400">
            © {new Date().getFullYear()} Kshetram Technologies. All rights reserved.
          </p>
          <div className="flex gap-6">
              <button className="text-xs text-gray-400 hover:text-gray-600">Privacy Policy</button>
              <button className="text-xs text-gray-400 hover:text-gray-600">Terms of Service</button>
          </div>
        </div>
      </div>
    </footer>
  );
};
